module.exports = __webpack_public_path__ + "static/media/videoPlayBtn.86421f3f.png";